!function() {
  "use strict";
  customElements.get("shopping-cart") || customElements.define("shopping-cart", class extends HTMLElement {
    constructor() {
      super(), this.form = this.querySelector("form"), this.discounts = this.querySelectorAll('[name="discount"]');
    }
    connectedCallback() {
      this.addEventListener("change", (event => this.onChangeHandler(event))), this.addEventListener("input", (event => this.onInputHandler(event))), 
      this.addEventListener("click", (event => this.onClickHandler(event))), window.addEventListener("cart:added", (() => this.update(!0))), 
      window.addEventListener("octane.quiz.addToCart", (() => this.update(!0))), location.hash.includes("#Cart") && (document.querySelector("#Cart")?.click(), 
      location.hash = "");
    }
    loadStart(el) {
      el?.classList.add("opacity-50", "cursor-wait");
    }
    loadEnd(el) {
      el?.classList.remove("opacity-50", "cursor-wait");
    }
    update() {
      let open = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], sections = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "cart-drawer", facets = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      try {
        sections = sections.replace("cart-drawer", document.querySelector("shopping-cart").closest(".shopify-section").getAttribute("id").match(/shopify-section-(.*)$/)[1]);
      } catch (e) {}
      const openCart = !!open || document.getElementById("Cart").checked;
      fetch(`${location.pathname}?sections=${sections}`, {
        method: "GET"
      }).then((response => response.json())).then((json => {
        Object.entries(json).forEach((entry => {
          const [section, html] = entry, parsedHTML = (new DOMParser).parseFromString(html, "text/html");
          facets ??= [ `[id^="shopify-section-"][id$="${section}"]` ], facets.push("[data-cart-count]"), 
          facets.forEach((selector => {
            document.querySelectorAll(selector).forEach((el => {
              const newHTML = parsedHTML.querySelector(selector);
              newHTML && (el.innerHTML = openCart ? newHTML.innerHTML.replace('id="Cart"', 'id="Cart" checked') : newHTML.innerHTML);
            }));
          }));
        }));
      }));
    }
    async checkFreeGifts() {
      let cart = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (cart = cart || await fetch(Shopify.routes.root + "cart.js").then((response => response.json())), 
      cart.items.length !== cart.items.filter((item => item.properties._Gifted)).length) return Promise.resolve();
      fetch(Shopify.routes.root + "cart/clear.js").then(this.update).then((() => Promise.resolve()));
    }
    onChangeHandler(event) {
      if ("discount" === event?.target?.getAttribute("name")) return;
      event?.preventDefault(), event?.stopPropagation();
      const lineItem = event?.target?.closest("[data-line-item]"), quantity = lineItem ? parseInt(lineItem.querySelector('[type="number"]')?.value) : null;
      lineItem && lineItem.hasAttribute("data-bundle") && this.querySelectorAll(`[data-bundle="${lineItem.dataset.bundle}"] [type="number"]`).forEach((q => q.value = quantity)), 
      this.loadStart(lineItem || event?.target), fetch(Shopify.routes.root + "cart/update.js", {
        method: "POST",
        body: new FormData(this.form)
      }).then((response => {
        if (response.ok) return response.json();
        console.warn(response), this.form.submit();
      })).then((cart => {
        0 === cart?.item_count || 0 === quantity ? this.update() : this.checkFreeGifts(cart).then((() => {
          this.update(!0, "cart-drawer", [ "[data-progress]", "[data-progress-mobile]", "[data-products]", "[data-upsell]", "[data-line-items]", "[data-cart-total]" ]);
        }));
      })).catch((error => {
        console.warn(error), this.form.submit();
      })).finally((() => this.loadEnd(lineItem || event?.target)));
    }
    onClickHandler(event) {
      if (event.target.hasAttribute("data-ajax")) {
        event.preventDefault();
        const url = event.target?.dataset.ajax || event.target?.href, lineItem = event?.target?.closest("[data-line-item]");
        this.loadStart(lineItem || event?.target), lineItem && lineItem.hasAttribute("data-bundle") && url.includes("=0") ? (this.querySelectorAll(`[data-bundle="${lineItem.dataset.bundle}"] [type="number"]`).forEach((q => q.value = 0)), 
        this.onChangeHandler(event)) : fetch(url.replace(/(\?(.*))?$/, ".js$1"), {
          method: "GET"
        }).then((response => {
          response.ok ? this.checkFreeGifts().then((() => {
            this.update({
              facets: event.target.hasAttribute("data-remove") ? [ "[data-line-items]", "[data-cart-total]" ] : null
            });
          })) : (console.warn(response), location.href = url);
        })).catch((error => {
          console.warn(error), location.href = url;
        }));
      } else event.target.hasAttribute("data-selling-plan") ? this.updateSellingPlan(event.target.dataset.line, event.target.dataset.sellingPlan, event) : event.target.hasAttribute("data-apply") && this.applyDiscount();
    }
    onInputHandler(event) {
      "discount" === event.target.getAttribute("name") ? this.querySelectorAll('[name="discount"]').forEach((el => {
        el != event.target && (el.value = event.target.value);
      })) : "note" === event.target.getAttribute("name") && fetch(Shopify.routes.root + "cart/update.js", {
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({
          note: event.target.value
        })
      });
    }
    updateSellingPlan(line, selling_plan_id) {
      let event = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      line && (event?.preventDefault(), this.loadStart(event?.target), fetch(Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          line: line,
          quantity: this.querySelector(`[data-line="${line}"] input`).value || 1,
          selling_plan: selling_plan_id.length ? parseInt(selling_plan_id) : ""
        })
      }).then((response => {
        response.ok ? this.update(!0, "cart-drawer", [ `[data-line="${line}"]`, "[data-progress]", "[data-progress-mobile]", "[data-products]", "[data-upsell]", "[data-line-items]", "[data-cart-total]" ]) : console.warn(response);
      })).catch((error => console.warn(error))));
    }
    saveDiscount() {
      let code = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
      var formData = new FormData;
      formData.append("attributes[_Discount]", code), fetch(Shopify.routes.root + "cart/update.js", {
        method: "POST",
        body: formData
      }).then((() => this.update(!0)));
    }
    discountStatus(message) {
      let success = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      const div = document.createElement("div");
      div.classList.add(success ? "text-green" : "text-red"), div.textContent = message, 
      this.querySelectorAll("[data-discount-status]").forEach((el => {
        el.innerHTML = "", el.appendChild(div);
      }));
    }
    applyDiscount() {
      const code = this.discounts[0]?.value;
      code && (this.discounts.forEach(this.loadStart), fetch(`/discount/${code}`).then((response => {
        if (console.log(response.statusText), response.ok) return response;
        throw new Error(response.statusText);
      })).then((async () => {
        this.saveDiscount(code), this.discountStatus(window.strings.discount.success, !0);
      })).catch((error => {
        console.warn(error), this.discountStatus(window.strings.discount.error, !1);
      })).finally((() => this.discounts.forEach(this.loadEnd))));
    }
  });
}();